import React from 'react';
import { Button, Flex, HStack } from '@chakra-ui/react';
import SaveSplitButton from './SaveSplitButton';
import { ANALYTICS_EVENTS, trackEvent } from '../../analytics';

// Edit-mode bar: AI Assist on the left (when onTextAssist is given), Cancel and Save on
// the right. In view mode, a single Edit button.
const EditControls = ({
  isEditing,
  isSaving,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onTextAssist,
  isTextAssisting = false,
  canRequestTextAssist = false,
  mb = 4
}) => {
  if (!isEditing) {
    return (
      <Flex justifyContent="flex-end" mb={mb}>
        <Button
          colorScheme="blue"
          variant="solid"
          px={6}
          fontWeight="semibold"
          leftIcon={<i className="bi bi-pencil" aria-hidden="true" />}
          onClick={onStartEdit}
        >
          Edit
        </Button>
      </Flex>
    );
  }

  return (
    <Flex justifyContent={onTextAssist ? 'space-between' : 'flex-end'} alignItems="center" gap={4} mb={mb} flexWrap="wrap">
      {onTextAssist && (
        <Button
          colorScheme="blue"
          variant="outline"
          bg="transparent"
          leftIcon={<i className="bi bi-stars" aria-hidden="true" />}
          _hover={{ bg: 'blue.50' }}
          onClick={() => {
            trackEvent(ANALYTICS_EVENTS.AI_ASSIST_USED);
            onTextAssist();
          }}
          isLoading={isTextAssisting}
          loadingText="Assisting"
          isDisabled={isSaving || !canRequestTextAssist}
        >
          AI Assist
        </Button>
      )}
      <HStack spacing={4}>
        <Button colorScheme="blue" variant="ghost" onClick={onCancelEdit} isDisabled={isSaving}>
          Cancel
        </Button>
        <SaveSplitButton isSaving={isSaving} onSave={onSaveEdit} />
      </HStack>
    </Flex>
  );
};

export default EditControls;
